import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import Loader from "react-loader-spinner";
import cogoToast from "cogo-toast";
import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import orderService from "../services/new-order-service";
import moment from "moment";
import {
  getOrders,
  clearOrders,
  getPatIdForRefill,
  clearPatIdForRefill,
  updatePatId,
} from "../state/reducers/patientSlice";
import jsPDF from "jspdf";
import { Modal } from "react-responsive-modal";

const tablePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug name" },
    { key: "rxf_number", title: "RX #" },
    { key: "pat_name", title: "Patient Name" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "rxf_number",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};
const tableNotEligiblePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug name" },
    { key: "rxf_number", title: "RX #" },
    { key: "reason", title: "Reason" },
    { key: "earliest_refill_date", title: "Earliest Refill Date" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "rxf_number",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};
const tablePropsInitSubstitute = {
  columns: [
    { key: "drg_name", title: "Drug name" },
    { key: "rxf_number", title: "RX #" },
    { key: "start_date", title: "Start date" ,style: { width: "110px" } },
    { key: "dly_qty", title: "Daily Quantity" },
    { key: "qty_dose", title: "Daily Dose" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "drg_name",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 50,
    position: PagingPosition.Bottom,
  },
};
const Refill = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [tablePropsSub, changeTablePropsSub] = useState(
    tablePropsInitSubstitute
  );

  const [allSubRecords, setAllSubRecords] = useState([]);
  const [allRecords, setAllRecords] = useState([]);
  const [neRecords, setNERecords] = useState([]);
  const [tableNotEligibleProps, changeTableNotEligibleProps] = useState(
    tableNotEligiblePropsInit
  );
  const dispatchSlice = useDispatch();
  var { orderList } = useSelector(getOrders);
  var { patId } = useSelector(getPatIdForRefill);

  const [rxcode, setRxcode] = useState("");
  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/cross.svg"
            className="m-auto w-4 h-4"
            onClick={() => {
              let items = allRecords.filter(
                (item) => item.rxf_number !== rowData.rxf_number
              );
              setAllRecords(items);
            }}
            alt="delete"
            title="Delete"
          />
        </span>
      </div>
    );
  };
  const CustomCellNEActions = ({ rowData }) => {
    return (
      <div
        className="action_btns"
        onClick={() => {
          handleNEClick(rowData);
        }}
      >
        <button
            className="text-white w-full sm:w-auto h-6 px-4 bg-login_btn rounded text-xs font-medium capitalize focus:outline-none"
          >
            SUB
          </button>
      </div>
    );
  };
  const CustomCellSubActions = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          <button
            className="text-white w-full sm:w-auto h-6 px-4 bg-login_btn rounded text-xs font-medium capitalize focus:outline-none"
            onClick={() => handleSelectClick(rowData)}
          >
            Select
          </button>
        </span>
      </div>
    );
  };
  const CustomCellStartDate = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          {rowData?.start_date ? moment.utc(rowData?.start_date).format("MM-DD-YYYY") : ""}
        </span>
      </div>
    );
  };
  const CustomCellEarliestRefillDate = ({ rowData }) => {
    const date = rowData?.earliest_refill_date;
    const reason = rowData?.reason;
    const normalizedReason = reason?.replace(/\.+$/, "");
    const hideDate = normalizedReason === "PRESCRIPTION EXPIRED" || normalizedReason === "MEDICATION ON AUTOREFILL" || normalizedReason === "NO MORE REFILLS LEFT" || normalizedReason === "NO REFILLS";
    const formatted = date && moment.utc(date).year() !== 1899 && !hideDate
      ? moment.utc(date).format("MM-DD-YYYY")
      : "";
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          {formatted}
        </span>
      </div>
    );
  };
  const CustomCellPatientName = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
         {rowData?.pat_lname + ", " + rowData?.pat_fname + " (" + (rowData?.pat_acct_num || moment(rowData?.pat_dob).format("MM-DD-YYYY")) + ")"}
        </span>
      </div>
    );
  };
  const handleSelectClick = (data) => {
    if(allRecords.findIndex(item => item.rxf_number=== data.rxf_number) === -1){
      setAllRecords([data, ...allRecords]);
    }

    var records = neRecords?.filter(
      (item) => item.rxf_number !== seletedRecord.rxf_number
    );
    setNERecords(records);
    setOpen(false);
    setAllSubRecords([]);
    setSelectedRecord("");
  };
  const [seletedRecord, setSelectedRecord] = useState("");
  const handleNEClick = async (data) => {
    try {
      setLoading(true);
      var resp = await orderService.getSubstituteDrugs(data?.rxf_number);
      resp = resp?.filter(item =>  item?.rxf_number !== data?.rxf_number);
      setLoading(false);
      if(resp?.length > 0){
        setSelectedRecord(data);
        dispatchSub(updateData(resp));
        setAllSubRecords(resp);
        setOpen(true);
      }else{
        const { hide } = cogoToast.error("No alternative scripts found", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }
      
    } catch (ex) {
      setLoading(false);
      const { hide } = cogoToast.error(ex.message, {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  const dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData && rxcode !== "") {
      try {
        dispatch1(updateData([]));
      } catch (e) {
        setLoading(false);
        const { hide } = cogoToast.error(
          "Error retrieving delivery information. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  const dispatchNotEligible = async (action) => {
    try {
      changeTableNotEligibleProps((prevState) => kaReducer(prevState, action));
      if (action.type === ActionType.LoadData) {
        dispatchNotEligible(updateData([]));
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error retrieving delivery information. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const dispatchSub = async (action) => {
    try {
      changeTablePropsSub((prevState) => kaReducer(prevState, action));
      if (action.type === ActionType.LoadData) {
        // dispatchSub(updateData([]));
      }
    } catch (e) {
      setLoading(false);
      const { hide } = cogoToast.error(
        "Error retrieving delivery information. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const onSubmit = async () => {
    try {
      setLoading(true);
      var items = allRecords?.map((item) => item.rxf_id);
      if (items?.length === 0) {
        setLoading(false);
        return;
      }
      await orderService.submitRefills(items);
      dispatchSlice(clearPatIdForRefill());
      setAllRecords([]);
      setNERecords([]);
      setAllSubRecords([]);
      setLoading(false);
      const { hide } = cogoToast.success("Data submitted successfully.", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
      if (orderList?.length > 0) {
        dispatchSlice(updatePatId(patId));
        dispatchSlice(clearOrders());
        await history.push("/patientDetails");
      }
    } catch (ex) {
      setLoading(false);
      const { hide } = cogoToast.error(ex.message, {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  const downloadReport = async () => {
    const doc = new jsPDF("", "", "a3");
    doc.setFont("helvetica");
    doc.setFontSize(9);
    doc.text("Clinical Solutions Pharmacy", 140, 20, "center");
    doc.text("NOT ELIGIBLE RECORDS", 140, 30, "center");

    let col = [ "RXF Number", "Drug Name", "Patient Name", "Account Number", "Date of Birth", "Reason", "Doctor Name", "Earliest Refill Date"];
    let rows = [];
    doc.setFontSize(12);
    doc.setFont("helvetica");
    doc.setFontSize(8);
    let top = 145;
    neRecords.forEach((ele, i) => {
      const refillMoment = moment.utc(ele.earliest_refill_date);

      const formattedRefillDate =
        ele.earliest_refill_date &&
        refillMoment.isValid() &&
        refillMoment.year() !== 1899 &&
        ele.reason !== "PRESCRIPTION EXPIRED."
          ? refillMoment.format("MM-DD-YYYY")
          : "";
          
      let temp = [ ele.rxf_number, ele.drg_name, ele.pat_fname+ ", " + ele.pat_lname,  ele.pat_acct_num , moment(ele.pat_dob).format("MM-DD-YYYY"),  ele.reason, ele.doc_fname+ ", " + ele.doc_lname, formattedRefillDate];
      top = top + 5;
      rows.push(temp);
    });
    doc.autoTable(col, rows, { startY: 40 }, "left");
    doc.save("NotEligibleRecords.pdf");
  };
  const getRecords = async (e, list) => {
    try {
      var code = e?.target?.value;
      var items = [];
      if (e?.key === "Enter" && rxcode !== "") {
        setRxcode("");
        setLoading(true);
        dispatchSlice(clearOrders());
        let rxfNum = code.length >= 11 ? code.substring(0, 8) : code;
        items = [rxfNum];
        let data = await orderService.getVerifyRefills(items);
        if (data[0]?.status === "Y" && allRecords.findIndex(item => item?.rxf_number=== data[0]?.rxf_number) === -1) {
          setAllRecords(allRecords => [...allRecords, ...data]);
        } else if(data[0]?.status !== "Y" &&  neRecords.findIndex(item => item?.rxf_number=== data[0]?.rxf_number) === -1) {
          setNERecords(neRecords => [...neRecords, ...data]);
        }
      } else if (orderList?.length > 0) {
        setLoading(true);
        items = orderList?.map((item) => item?.rxf_number);
        let data = await orderService.getVerifyRefills(items);
        var eligibleItems = data.filter((item) => item.status === "Y");
        var notEligibleItems = data.filter((item) => item.status !== "Y");
        setAllRecords(eligibleItems);
        setNERecords(notEligibleItems);
      }

      setLoading(false);
    } catch (ex) {
      setLoading(false);
      const { hide } = cogoToast.error(ex.message, {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };

  useEffect(() => {
    dispatch1(updateData(allRecords))
  }, [allRecords]);
  useEffect(() => {
    dispatchNotEligible(updateData(neRecords))
  }, [neRecords]);

  useEffect(() => {
    if (orderList?.length) {
      getRecords(null, orderList);
    }
    return function cleanup() {
      dispatchSlice(clearOrders());
    };
  }, []);
  const [open, setOpen] = useState(false);
  const onCloseModal = () => {
    setOpen(false);
    setAllSubRecords([]);
    dispatchSub(updateData([]));
  };
  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={open} onClose={onCloseModal} center>
        <div className=" text-xs usersList p-4 gridList overflow-x-auto">
        <h3
              className="text-lg leading-6 font-medium text-gray-900 text-labelclr font-semibold pb-4 tracking-wider"
              id="modal-headline"
            >
              Select Alternative Drug
            </h3>
            <h1
              className="text-md leading-6 font-medium text-gray-900 text-labelclr font-semibold pb-4  tracking-wider"
              id="modal-headline"
            >
              Original order - {seletedRecord?.drg_name} ({seletedRecord?.rxf_number})
            </h1>

          <Table
            {...tablePropsSub}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCellSubActions {...props} />;
                     case "start_date":
                        return <CustomCellStartDate {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatchSub}
          />
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">Batch Refill</span>
          </div>
        </div>
        <div className="w-full pt-4 pl-2 justify-center">
          <ul>
            <li className="inline-block text-xs pr-3 leading-6 text-menu_txt w-full mb-3">
              <div className="flex w-full">
                <label className="text-labelclr mt-1 mr-3 ml-2 font-semibold text-xl tracking-wider">
                  Scan Rx Number
                </label>
                <div className="w-1/3">
                  <input
                    type="text"
                    name="rxCode"
                    id="rxCode"
                    disabled={orderList?.length > 0 }
                    value={rxcode}
                    autoFocus={true}
                    placeholder="Scan RX Number"
                    onChange={(e) => setRxcode(e.target.value)}
                    onKeyDown={(e) => getRecords(e)}
                    className="border focus:outline-none  w-full focus:none h-10 rounded-md pl-3 text-sm font-normal w-full"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="w-full flex px-3 py-3">
          <div className="w-1/2 border px-3 py-3 mr-1">
            <div className="tableHeader flex clearboth ">
              <div className="w-1/2 text-darkclr font-semibold leading-10 ">
                <label className="text-labelclr font-semibold text-md tracking-wider">
                  ELIGIBLE
                </label>
              </div>
              <div className="w-full sm:w-1/2 text-right">
                <span className="relative">
                  <input
                    type="search"
                    defaultValue={tableProps.searchText}
                    onChange={(event) => {
                      dispatch1(search(event.currentTarget.value));
                    }}
                    placeholder=" Search"
                    className="border rounded w-full mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
                  />
                  <img
                    src="/img/search-2.svg"
                    alt=""
                    className="absolute w-4 h-4 right-5 -top-3"
                  ></img>
                </span>
              </div>
            </div>

            <div className=" text-xs usersList gridList overflow-x-auto">
              <Table
                {...tableProps}
                childComponents={{
                  cellText: {
                    content: (props) => {
                      // eslint-disable-next-line default-case
                      switch (props.column.key) {
                        case "Actions":
                          return <CustomCell {...props} />;
                        case "pat_name":
                          return <CustomCellPatientName {...props} />;
                      }
                    },
                  },
                }}
                dispatch={dispatch1}
              />
            </div>
          </div>
          <div className="w-1/2 border px-3 py-3 justify-end">
            <div className="tableHeader mb-2 flex clearboth ">
              <div className="w-1/2 text-darkclr font-semibold leading-10 truncate">
                <label className="text-labelclr font-semibold text-md tracking-wider">
                  NOT ELIGIBLE
                </label>
              </div>
              <div className="w-full sm:w-1/2 text-right">
                <span className="mr-3">
                  <button
                    onClick={() => downloadReport()}
                    disabled={neRecords?.length === 0}
                    type="button"
                    className={
                      neRecords?.length === 0
                        ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-10 px-6  bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                        : "text-white w-full sm:w-auto h-10 px-6 cursor-pointer bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    }
                  >
                    DOWNLOAD
                  </button>
                </span>
              </div>
            </div>
            <div className=" text-xs usersList gridList overflow-x-auto">
              <Table
                {...tableNotEligibleProps}
                childComponents={{
                  cellText: {
                    content: (props) => {
                      // eslint-disable-next-line default-case
                      switch (props.column.key) {
                        case "Actions":
                          return <CustomCellNEActions {...props} />;
                        case "earliest_refill_date":
                          return <CustomCellEarliestRefillDate {...props} />;
                      }
                    },
                  },
                }}
                dispatch={dispatchNotEligible}
              />
            </div>
          </div>
        </div>
        <div className="mx-3">
          <button
            disabled={ allRecords?.length === 0 || loading}
            className={
              allRecords?.length === 0 || loading
                ? "opacity-50 cursor-not-allowed text-rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                : "rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
            }
            onClick={() => {
              setLoading(true);
              onSubmit();
            }}
          >
            SUBMIT
          </button>
        </div>
      </div>
    </>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(Refill)
);